// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27-oZ","rootMobile":"styles_rootMobile__s5xN9"};